// The institution's support contact (Setup › Support Contact), for anyone
// signed in — the help pages and the exam lobby show it (parity audit 2, 4.1).
// Backend: GET /api/setup/support → { institution, email, phone, hours }.
//
// The API client is loaded when the contact is asked for, not when a screen
// that shows it is imported: the lobby is rendered in tests that mock only the
// exam service, and the client refuses to load without runtime config.
export const getSupportContact = async () => {
  const { default: api } = await import("./api");
  const response = await api.get("/setup/support");
  return response.data?.data || null;
};
